export const flyingEyeDead = new Image();
flyingEyeDead.src = "assets/characterSprites/flyingEye/Death.png";
flyingEyeDead.width = 1200/8;
flyingEyeDead.height = 150/1;
flyingEyeDead.yOffset = 40;
flyingEyeDead.xOffset = 150;
flyingEyeDead.cycleLoop = [0,1,2,3,4,5,6,7];